import NavigationDrawer from './navigation';
// import PartnerPortalDrawer from './partner-portal';
// import SearchDrawer from './search';
import ContactFormDrawer from './contact-form';
// import TyreSizeDrawer from './tyre-size';
// import EUTyreLabelDrawer from './eu-tyre-label';

const init = () => {
    if (!window.customElements.get('navigation-drawer')) {
        window.customElements.define('navigation-drawer', NavigationDrawer);
    }

    // if (!window.customElements.get('partner-portal-drawer')) {
    //     window.customElements.define('partner-portal-drawer', PartnerPortalDrawer);
    // }

    // if (!window.customElements.get('search-drawer')) {
    //     window.customElements.define('search-drawer', SearchDrawer);
    // }

    if (!window.customElements.get('contact-form-drawer')) {
        window.customElements.define('contact-form-drawer', ContactFormDrawer);
    }

    // if (!window.customElements.get('tyre-size-drawer')) {
    //     window.customElements.define('tyre-size-drawer', TyreSizeDrawer);
    // }

    // if (!window.customElements.get('eu-tyre-label-drawer')) {
    //     window.customElements.define('eu-tyre-label-drawer', EUTyreLabelDrawer);
    // }

    const closeButtons = document.querySelectorAll('.js-close-drawer-button');
    if (closeButtons.length > 0) {
        closeButtons.forEach((button) => {
            button.addEventListener('click', () => button.dispatchEvent(
                new CustomEvent('dialog:force-close', {
                    bubbles: true,
                    cancelable: true,
                    composed: true,
                }),
            ));
        });
    }
};

export default init;
